import axios from 'axios'
import { URL_API } from './constants'

const urlBase =
  'https://i71xu8cd55.execute-api.us-west-1.amazonaws.com/desa/api'

/**
 * @param {string}  url url a la cual consultar
 * esta funcion detecta si es una nueva url base (comienza con http:// o https://).
 * en caso de ser asi, retorna la url. en caso contrario, se asume que es un fragmento
 * de path por lo que se concatena con la constante urlBase
 **/
const readUrl = (url = '') =>
  url.startsWith('http://') || url.startsWith('https://')
    ? url
    : `${URL_API}${url}`

/**
 * Instancia personalizada de axios para agregar interceptores
 */
const instance = axios.create()

const get = (url = '', headers = {}) =>
  instance.get(readUrl(url), {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...headers
    }
  })

const post = (url = '', body = {}, headers = {}) =>
  instance.post(readUrl(url), body, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...headers
    }
  })

const put = (url = '', body = {}, headers = {}) =>
  instance.put(readUrl(url), body, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...headers
    }
  })

const del = (url = '', headers = {}) =>
  instance.delete(readUrl(url), {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...headers
    }
  })

const client = {
  instance: instance,
  get: get,
  post: post,
  put: put,
  delete: del
}

export default client
